export const getDataAfterSubmit = ({ items, flats }) => {
  const failedFlatsIds = new Set();

  items.forEach((el) => {
    const { success, addressId } = el;

    if (!success) {
      failedFlatsIds.add(addressId);
    }
  });

  const failedFlats = flats.reduce((acc, req) => {
    const isFindSucceededFailed = failedFlatsIds.has(req.addressId);

    if (isFindSucceededFailed) {
      acc.push({ ...req });
    }

    return acc;
  }, []);

  return { failedFlats };
};
